module.exports = "<h1>Create new organization</h1>\n\n<div [hidden]=\"!error\" class=\"alert alert-danger\" role=\"alert\">\n  <strong>Error:</strong> {{error}}\n</div>\n\n<div *ngIf=\"model && success\" class=\"alert alert-success\" role=\"alert\">\n  <strong>Success!</strong> Organization created.\n  <a [routerLink]=\"['/organizations/edit', model.id]\">Edit organization</a> | <a routerLink=\"/organizations\">View All</a>\n</div>\n\n<org-form [loading]=\"loading\" (onSubmit)=\"createOrg($event)\"></org-form>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/orgs/create.org.component.html
// module id = 890
// module chunks = 1